import { useState } from 'react';
import Header from '@/components/feature/Header';
import MenuOverlay from '@/components/feature/MenuOverlay';
import SideActions from '@/components/feature/SideActions';
import ScrollProgress from '@/components/feature/ScrollProgress';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import Ticker from './components/Ticker';
import QuickActions from './components/QuickActions';
import Concept from './components/Concept';
import Schedule from './components/Schedule';
import Vendor from './components/Vendor';
import Performer from './components/Performer';
import Sponsor from './components/Sponsor';
import About from './components/About';
import Contact from './components/Contact';

export default function Home() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="bg-background-50">
      <ScrollProgress />
      <Header onMenuOpen={() => setMenuOpen(true)} />
      <MenuOverlay open={menuOpen} onClose={() => setMenuOpen(false)} />
      <SideActions />
      <main>
        <Hero />
        <Ticker />
        <QuickActions />
        <Concept />
        <Schedule />
        <Vendor />
        <Performer />
        <Sponsor />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}